export default {
  meta: {
    title: "五指互联网站内容管理系统(CMS)-五指CMS-wuzhicms-北京专业网站制作、开发。",
    description:
      "五指CMS是一款高性能的内容管理系统，是大型门户、军队、学校、医院、政府、媒体网站、企业网站建站首选网站管理系统。",
    keywords: "五指CMS、指内容管理系统、高性能网站系统",
  },
  nav: {
    logoAlt: "五指互联",
    products: "产品",
    services: "服务",
    doc: "文档",
    about: "关于我们",
    contact: "联系我们",
  },
  hero: {
    badge: "已服务全国 100+ 单位",
    title: "五指CMS",
    subtitle: "内容管理一站式解决方案",
    value1: "智慧",
    value2: "稳健",
    value3: "安全",
    ctaPrimary: "开启您的旅程",
    ctaSecondary: "查看演示",
  },
  features: {
    badge: "核心优势",
    title: "专业专注，值得信赖",
    description:
      "我们的解决方案将前沿技术与行业最佳实践相结合，为您交付卓越成果",
    items: [
      {
        title: "高性能架构",
        description:
          "全链路性能调优，低延迟、高并发承载，操作顺滑、反馈即时",
      },
      {
        title: "企业级安全",
        description:
          "契合主流合规要求，配合访问控制与审计追踪，守好核心数据",
      },
      {
        title: "弹性扩展",
        description:
          "模块化架构按域拆分，可独立扩缩与发布；随业务增长横向扩容，轻松应对业务增长",
      },
      {
        title: "全天候支持",
        description: "专属支持团队提供 7×24 小时全天候技术援助",
      },
      {
        title: "持续迭代更新",
        description: "定期功能增强与安全补丁，让您始终保持领先优势",
      },
      {
        title: "智能化运维",
        description:
          "AI 辅助决策、异常预警、智能运维，降低运维成本，提升系统稳定性",
      },
    ],
  },
  about: {
    badge: "关于 五指互联",
    title: "始于 2014，赋能数字未来",
    paragraph1:
      "我们是一支由技术极客与行业专家组成的先锋团队。十余年来，五指互联始终坚持以创新为驱动，致力为用户提最专业的内容管理系统解决方案。",
    paragraph2:
      "深耕云计算、人工智能及定制化软件开发领域，我们不仅是技术的构建者，更是企业数字化转型的长期战略伙伴。我们打造的每一个系统都兼具扩展性与安全性，助力您的业务在时代波动中稳操胜券。",
    stats: [
      { value: "100+", label: "服务单位" },
      { value: "500+", label: "交付项目" },
      { value: "10+", label: "年行业经验" },
      { value: "100%", label: "客户满意度" },
    ],
    cards: [
      {
        title: "创新优先",
        description: "突破边界的前沿解决方案",
      },
      {
        title: "专家团队",
        description: "经认证的专业人才，经验丰富",
      },
      {
        title: "安全为本",
        description: "每个解决方案均具备企业级安全保障",
      },
      {
        title: "成效卓著",
        description: "对业务增长产生可量化的影响",
      },
    ],
  },
  services: {
    badge: "我们的服务",
    title: "全方位技术解决方案",
    description:
      "从概念到部署，我们提供端到端的技术服务，助力您的企业在数字化浪潮中蓬勃发展",
    cta: "了解更多",
    list: [
      {
        title: "规划设计",
        description:
          "从需求分析到架构设计，提供专业的系统规划与设计方案，为项目奠定坚实基础。",
        features: ["需求分析", "架构设计", "原型验证"],
      },
      {
        title: "定制开发",
        description:
          "采用前沿技术量身打造解决方案，满足您独特的业务需求，驱动数字化转型。",
        features: ["敏捷开发", "可扩展架构", "质量保障"],
      },
      {
        title: "AI 与机器学习",
        description:
          "由先进 AI 算法驱动的智能自动化与预测分析，解锁全新业务机遇。",
        features: ["数据分析", "神经网络", "流程自动化"],
      },
    ],
  },
  testimonial: {
    badge: "客户评价",
    title: "深受用户信赖",
    description: "听听我们的客户讲述与 五指互联 合作的真实体验",
    list: [
      {
        name: "某用户",
        role: "某单位",
        image: "media/zh/testimonials/1.svg",
        content:
          "五指互联 将我们的遗留系统升级为现代化的云基础设施。他们在 AI 集成方面的专业能力，让我们在市场竞争中获得了显著优势。",
      },
      {
        name: "某用户",
        role: "某单位",
        image: "media/zh/testimonials/2.svg",
        content:
          "他们为我们打造的定制电商平台能够无缝处理数百万笔交易。对细节的极致关注和对卓越的不懈追求，令人叹服。",
      },
      {
        name: "某用户",
        role: "某单位",
        image: "media/zh/testimonials/3.svg",
        content:
          "与 五指互联 合作彻底改变了我们的业务格局。他们交付的 HIPAA 合规平台在功能性和安全性上都超出了我们的预期。",
      },
      {
        name: "某用户",
        role: "某单位 数字化转型总监",
        image: "media/zh/testimonials/4.svg",
        content:
          "五指互联 团队在项目交付上的高效令我们印象深刻。从需求分析到上线仅用了六周，系统稳定性和用户体验都达到了行业一流水准。",
      },
      {
        name: "某用户",
        role: "某单位 产品总监",
        image: "media/zh/testimonials/5.svg",
        content:
          "我们的在线教育平台在五指互联的技术支持下，并发用户承载量提升了十倍。他们对业务场景的深刻理解，让整个合作过程非常顺畅。",
      },
    ],
  },
  cta: {
    badge: "联系我们",
    title: "准备好开启数字化转型之旅了吗？",
    phoneValue: "+86 18310831187",
    emailValue: "zhw@wuzhicms.com",
    wechatQrSrc: "media/zh/wechat-qr.png",
    addressValue: "请使用微信扫描二维码，添加微信咨询。",
    lead:
      "让我们讨论如何通过我们的技术解决方案帮助您实现业务目标。我们的团队准备将您的愿景变为现实。",
    phoneLabel: "电话",
    emailLabel: "电子邮件",
    officeLabel: "微信",
    qrCodeAlt: "企业微信二维码",
    formName: "姓名",
    formNamePlaceholder: "张三",
    formEmail: "电子邮件地址",
    formEmailPlaceholder: "zhangsan@company.com",
    formCompany: "公司名称",
    formCompanyPlaceholder: "您的公司名称",
    formMessage: "消息",
    formMessagePlaceholder: "请告诉我们您的项目需求...",
    submit: "发送消息",
    submitting: "发送中...",
    success: "消息已发送成功！我们很快会回复您。",
    error: "发生了一些错误。请重试。",
    charCount: "{{count}}/500",
  },
  footer: {
    brand: "五指互联",
    tagline: "通过创新技术解决方案和数字化转型，赋能企业发展。",
    localFileLabel: "",
    localFileUrl: "media/zh/files/readme.txt",
    colSolutions: "解决方案",
    colCompany: "公司",
    colNewsletter: "订阅我们",
    solutions: ["定制开发", "云迁移", "AI 集成", "DevOps 服务"],
    companyAbout: "关于我们",
    companyCareers: "招聘",
    companyCase: "案例研究",
    companyContact: "联系我们",
    newsletterLead: "获取最新行业洞察与技术趋势",
    emailPlaceholder: "输入您的邮箱",
    subscribe: "订阅",
    subscribing: "提交中...",
    subscribeSuccess: "订阅成功！",
    subscribeError: "发生错误，请重试。",
    copyright: "© {{year}} 五指互联. 保留所有权利。",
  },
  notFound: {
    title: "页面未找到",
    subtitle: "此页面尚不存在。",
    hint: "告诉我们您希望在这里看到什么内容。",
  },
};

